
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { categoriesApi } from "../store/actions/campaign";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../store/reducers/languageReducer";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { translate } from "../utils";
import Skeleton from "react-loading-skeleton";
import { settingsData } from "../store/reducers/settingsReducer";
import "./pt-home.css";

SwiperCore.use([Navigation, Pagination]);

const CatNav = () => {
    const [Data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    const currentLanguage = useSelector(selectCurrentLanguage);
    const categoiresOnOff = useSelector(settingsData);

    useEffect(() => {
        setIsLoading(true);

        categoriesApi(
            "0",
            "40",
            currentLanguage.id,
            (response) => {
                setData(response.data || []);
                setIsLoading(false);
            },
            (error) => {
                if (error === "No Data Found") {
                    setData([]);
                }
                setIsLoading(false);
            }
        );
    }, [currentLanguage]);

    const swiperOption = {
        loop: Data.length > 10,
        speed: 600,
        spaceBetween: 12,
        slidesPerView: "auto",
        navigation: true,
        freeMode: true,
        observer: true,
        observeParents: true,
        breakpoints: {
            1200: {
                slidesPerView: "auto",
            },
        },
    };

    if (!categoiresOnOff || categoiresOnOff.category_mode !== "1") {
        return null;
    }

    return (
        <div id="cn-main" className="pt-catnav">
            <div className="container py-2">
                {isLoading ? (
                    <Skeleton height={48} />
                ) : Data.length > 0 ? (
                    <div className="cat-nav-layout">
                        <div className="cat-nav-slider">
                            <Swiper
                                {...swiperOption}
                                className="cat-nav-swiper"
                            >
                                {Data.slice(0, 10).map((element) => (
                                   <SwiperSlide
    key={element.id}
    className="cat-nav-slide"
>
                                        <Link
                                            className="pt-cat-chip"
                                            to={`/categories-view/${element.id}`}
                                            title={element.category_name}
                                        >
                                            {element.image ? (
                                                <img src={element.image} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} />
                                            ) : (
                                                <span className="pt-cat-initial" aria-hidden="true">
                                                    {String(element.category_name || "").trim().charAt(0)}
                                                </span>
                                            )}
                                            <span>{element.category_name}</span>
                                        </Link>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                        {Data.length > 10 && (
                            <button
                                type="button"
                                className="cat-nav-more"
                                onClick={() => navigate("/categories")}
                            >
                                {translate("More >>")}
                            </button>
                        )}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default CatNav;
